import Highcharts from 'highcharts';

// Side-effect imports to compose modules onto Highcharts (v12 ESM)
import 'highcharts/highcharts-more';
import 'highcharts/modules/exporting';
import 'highcharts/modules/export-data';
import 'highcharts/modules/data';
import 'highcharts/modules/accessibility';

// Frequently needed series/modules
import 'highcharts/modules/heatmap';
import 'highcharts/modules/treemap';
import 'highcharts/modules/sankey';
import 'highcharts/modules/networkgraph';
import 'highcharts/modules/wordcloud';
import 'highcharts/modules/solid-gauge';
import 'highcharts/modules/xrange';
import 'highcharts/modules/streamgraph';
import 'highcharts/modules/timeline';
import 'highcharts/modules/vector';

// Global defaults
Highcharts.setOptions({
  credits: { enabled: false },
  accessibility: { enabled: false },
  exporting: { enabled: false },
});

export default Highcharts;
